import React from 'react'
import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import traiwissLogo from 'src/assets/traiwiss_logo.png'
import styled from 'styled-components'

const SetPasswordForm = React.lazy(() => loadComponent('orga', 'SetPasswordForm'))

const StyledImage = styled.img`
    width: 50%;
`

export function SetPasswordRoute() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const onPasswordSet = useCallback(() => {
        navigate('/')
    }, [navigate])

    return (
        <SetPasswordForm
            header={<StyledImage src={traiwissLogo} alt="traiwiss logo" />}
            token={searchParams.get('token')}
            onPasswordSet={onPasswordSet}
        />
    )
}
